import React, { PureComponent } from 'react';
import Debugger from './Debugger';
import ExperimentProviderContext from './ExperimentProviderContext';

type ownProps = {
  environment?: string;
};

class DebuggerStrategy extends PureComponent<ownProps> {
  render() {
    return (
      <ExperimentProviderContext.Consumer>
        {providerState => {
          const { defaults = {}, ...restOfState } = providerState as any || {};
          const { environment, ...restOfProps } = this.props;
          const expState = {
            ...restOfState,
            ...restOfProps,
            environment: environment || defaults.environment || 'production'
          };
          return <Debugger {...expState} />;
        }}

      </ExperimentProviderContext.Consumer>
    );
  }
}

DebuggerStrategy.contextType = ExperimentProviderContext;

export default DebuggerStrategy;
